import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, filter } from 'rxjs';

import { CurrentProduct } from '@core/models/types/current-product.type';
import { LocalStorageService } from '../storage/local-storage.service';

export const EMPTY_PRODUCT = -1;

@Injectable({
  providedIn: 'root',
})
export class ProductStateService {
  localStorageService = inject(LocalStorageService);

  private currentProduct$ = new BehaviorSubject<CurrentProduct>({
    id: EMPTY_PRODUCT,
    name: '',
    description: '',
    value: 0,
    maxOrderQuantity: 0,
    quantity: Number(localStorage.getItem('quantity')) || 0,
    minimumPrize: 0,
    maximumPrize: 0,
    capPercentage: 0,
    rafflePercentage: 0,
    susepNumber: '',
    maximumSecondaryPrize: 0,
    commercialName: '',
  });
  currentProduct = this.currentProduct$
    .asObservable()
    .pipe(filter(product => product.id > EMPTY_PRODUCT));

  get product(): CurrentProduct {
    return this.currentProduct$.value;
  }

  setProduct(evento: CurrentProduct): void {
    this.currentProduct$.next(evento);
  }

  updateProduct(evento: Partial<CurrentProduct>): void {
    const current = this.currentProduct$.value;
    this.currentProduct$.next({ ...current, ...evento });
  }

  setQuantity(quantity: number): void {
    const current = this.currentProduct$.value;
    this.currentProduct$.next({ ...current, quantity: quantity });
    this.localStorageService.set('quantity', quantity);
  }

  resetQuantity(): void {
    const current = this.currentProduct$.value;
    this.currentProduct$.next({ ...current, quantity: 0 });
    this.localStorageService.remover('quantity');
  }

  productIsValid(): boolean {
    const current = this.currentProduct$.value;
    return current.id > EMPTY_PRODUCT;
  }
}
